export const CATEGORIES_WITHOUT_FEATURED_CAROUSEL = ['eletro', 'games'];

export const shouldRenderFeaturedCarousel = (slug: string): boolean => !CATEGORIES_WITHOUT_FEATURED_CAROUSEL.includes(slug);
